import { versionNumber } from '../../../../utils/constant';
import { StyledVersionNumber } from '../styles/sx';

const VersionNumber = () => {
  return <StyledVersionNumber variant={'subtitle1'}>{versionNumber}</StyledVersionNumber>;
};

export default VersionNumber;
